module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"price":{"label":"Amount","placeholder":"0"}}}')
  delete Component.options._Ctor
}
